import React, { useMemo } from 'react';
import { Tag } from './Tag';

type Props = {
  count?: number;
};

export function TagSkeletons({ count = 5 }: Props) {
  const randomWidths = useMemo(
    () => Array.from({ length: count }, () => 60 + Math.random() * 75),
    [count],
  );

  return (
    <>
      {randomWidths.map((minWidth, index) => (
        <Tag key={index} name="&nbsp;" style={{ minWidth }} isLoading={true} />
      ))}
    </>
  );
}
